import { Box, Button, Flex, Form } from 'dash-ui';

import {
  SaleTeamSelect,
  ContactUrlInput,
  CommissionInput,
  SaleDirectorSelect,
  SaleAssociateSelect,
} from './components/';
import { ISaleTeamItemProps } from './SaleTeamItem.interfaces';
import { FlexWraper } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/components/SaleTeams/components/SaleTeamItem/SaleTeamItem.style';

function SaleTeamItem({
  saleTeamIndex,
  saleTeamsList,
  onDeleteSaleTeamClick,
  disabled,
}: ISaleTeamItemProps) {
  return (
    <Flex w="100%" mt={4}>
      <Box flex={1}>
        <Form.Group w="100%" mt={4}>
          <FlexWraper>
            <SaleTeamSelect
              disabled={disabled}
              saleTeamsList={saleTeamsList}
              saleTeamIndex={saleTeamIndex}
            />
            <SaleDirectorSelect
              saleTeamIndex={saleTeamIndex}
              disabled={disabled}
            />
            <SaleAssociateSelect
              saleTeamIndex={saleTeamIndex}
              disabled={disabled}
            />
          </FlexWraper>
        </Form.Group>
        <Form.Group w="100%" mt={4}>
          <Flex flex={1} alignItems="flex-end">
            <CommissionInput
              saleTeamIndex={saleTeamIndex}
              disabled={disabled}
            />
            <ContactUrlInput
              saleTeamIndex={saleTeamIndex}
              disabled={disabled}
            />
            <Flex flex={1} />
          </Flex>
        </Form.Group>
      </Box>
      {saleTeamIndex !== 0 && (
        <Button
          square
          icon="fillTrash"
          variation="flat"
          mt={7.5}
          ml={2}
          iconProps={{ size: 24 }}
          colorVariation="danger"
          disabled={disabled}
          onClick={() => onDeleteSaleTeamClick(saleTeamIndex)}
        />
      )}
    </Flex>
  );
}

export default SaleTeamItem;
